"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listPriceConfirmStep = exports.listPriceCreateStep = exports.createOptionStep = exports.selectMerchantStep = exports.generalModalMessages = exports.listPriceInitiatorButtonMessages = void 0;

var _reactIntl = require("react-intl");

var listPriceInitiatorButtonMessages = (0, _reactIntl.defineMessages)({
  listPriceInitiatorButtonText: {
    id: 'listPriceInitiatorButton.listPriceInitiatorButtonText',
    description: 'Text for Catalog Price Initiator Button.',
    defaultMessage: 'Initiate Contract'
  },
  noIdentityMessage: {
    id: 'listPriceInitiatorButton.noIdentityMessage',
    description: 'Error for not having access to any merchant identities.',
    defaultMessage: 'You have no merchant identity to perform this action'
  },
  noSkusSelectedMessage: {
    id: 'listPriceInitiatorButton.noSkusSelectedMessage',
    description: 'Error for not selecting skus before creating a contract.',
    defaultMessage: 'Valid SKUs need to be selected before creating a contract'
  },
  tooltipMessage: {
    id: 'listPriceInitiatorButton.tooltipMessage',
    description: 'Tooltip message for list price initiator button',
    defaultMessage: '{message}. For support, please contact {email}'
  }
});
exports.listPriceInitiatorButtonMessages = listPriceInitiatorButtonMessages;
var generalModalMessages = (0, _reactIntl.defineMessages)({
  defaultErrorCreationMessage: {
    id: 'generalModal.defaultErrorCreationMessage',
    description: 'Default error creation message.',
    defaultMessage: 'Error creating catalog price contract'
  },
  termButtonCreatingStatus: {
    id: 'generalModal.termButtonCreatingStatus',
    description: 'Status displayed when term is being created.',
    defaultMessage: 'Creating'
  },
  termButtonCreatedStatus: {
    id: 'generalModal.termButtonCreatedStatus',
    description: 'Status displayed when term is created.',
    defaultMessage: 'Created'
  },
  termButtonDefaultText: {
    id: 'generalModal.termButtonDefaultText',
    description: 'Default text for term button.',
    defaultMessage: 'Send for approval'
  },
  nextButtonText: {
    id: 'generalModal.nextButtonText',
    description: 'Text for next button.',
    defaultMessage: 'Next'
  },
  backButtonText: {
    id: 'generalModal.backButtonText',
    description: 'Text for back button.',
    defaultMessage: 'Back'
  },
  closeButtonText: {
    id: 'generalModal.closeButtonText',
    description: 'Text for close button.',
    defaultMessage: 'Close'
  },
  viewPendingContractText: {
    id: 'generalModal.viewPendingContractText',
    description: 'Text for view pending contract',
    defaultMessage: 'Click here to view the pending contract in the Contract Manager'
  },
  title: {
    id: 'generalModal.title',
    description: 'Title for modal',
    defaultMessage: 'Initiate Catalog Price Contract'
  },
  pleaseContactText: {
    id: 'generalModal.pleaseContactText',
    description: 'Please contract text',
    defaultMessage: 'Please contact'
  },
  financialFlowsSupportText: {
    id: 'generalModal.financialFlowsSupport',
    description: 'Financial Flows Support text',
    defaultMessage: 'Financial Flows Support'
  },
  forAssistanceText: {
    id: 'generalModal.forAssistanceText',
    description: 'For assistance text',
    defaultMessage: 'for assistance'
  }
});
exports.generalModalMessages = generalModalMessages;
var selectMerchantStep = (0, _reactIntl.defineMessages)({
  header: {
    id: 'selectMerchantStep.header',
    description: 'Header for select merchant step.',
    defaultMessage: 'Select the merchant buying products'
  },
  merchantSelectLabel: {
    id: 'selectMerchantStep.merchantSelectLabel',
    description: 'Merchant select label.',
    defaultMessage: 'Merchant'
  }
});
exports.selectMerchantStep = selectMerchantStep;
var createOptionStep = (0, _reactIntl.defineMessages)({
  header: {
    id: 'createOptionStep.header',
    description: 'Header for create option step.',
    defaultMessage: 'You already have catalog price contracts with {name}. Either add the products to existing contract or create a new one'
  },
  updateExistingOptionButtonTitle: {
    id: 'createOptionStep.updateExistingOptionButtonTitle',
    description: 'Title for update existing option button.',
    defaultMessage: 'Update existing contract'
  },
  updateExistingOptionButtonDescription: {
    id: 'createOptionStep.updateExistingOptionButtonDescription',
    description: 'Description for update existing option button.',
    defaultMessage: 'Add skus to existing contract with {name}'
  },
  newOptionButtonTitle: {
    id: 'createOptionStep.newOptionButtonTitle',
    description: 'Title for new option button.',
    defaultMessage: 'Initiate new contract'
  },
  newOptionButtonDescription: {
    id: 'createOptionStep.newOptionButtonDescription',
    description: 'Description for new option button.',
    defaultMessage: 'Create new contract with {name}'
  }
});
exports.createOptionStep = createOptionStep;
var listPriceCreateStep = (0, _reactIntl.defineMessages)({
  existingHeader: {
    id: 'listPriceCreateStep.existingHeader',
    description: 'Header for catalog price create step for existing contract.',
    defaultMessage: 'Select from Catalog Contracts with {name}'
  },
  newHeader: {
    id: 'listPriceCreateStep.newHeader',
    description: 'Header for catalog create step for new contract.',
    defaultMessage: 'Name your contract'
  },
  contractNamePlaceholder: {
    id: 'createOptionStep.contractNamePlaceholder',
    description: 'Placeholder for new contract name',
    defaultMessage: 'e.g. Catalog Price term with {name}'
  }
});
exports.listPriceCreateStep = listPriceCreateStep;
var listPriceConfirmStep = (0, _reactIntl.defineMessages)({
  errorLoadingSkusMessage: {
    id: 'listPriceConfirmStep.errorLoadingSkusMessage',
    description: 'Error message for loading skus.',
    defaultMessage: 'Error Loading Skus'
  },
  allSkusHaveContractsErrorMessage: {
    id: 'listPriceConfirmStep.allSkusHaveContractsErrorMessage',
    description: 'Error message displayed when all skus have contracts.',
    defaultMessage: 'All skus have a catalog price contract between {merchantName} and {fulfillerName}'
  },
  skusHaveContractsWarning: {
    id: 'listPriceConfirmStep.skusHaveContractsWarning',
    description: 'Error message displayed when all skus have contracts.',
    defaultMessage: 'A catalog price contract between {fulfillerName} and {merchantName} already exists for these skus'
  },
  discount: {
    id: 'listPriceConfirmStep.discount',
    description: 'Discount text.',
    defaultMessage: 'Discount'
  },
  markup: {
    id: 'listPriceConfirmStep.markup',
    description: 'Markup text.',
    defaultMessage: 'Markup'
  },
  buyer: {
    id: 'listPriceConfirmStep.buyer',
    description: 'Buyer text.',
    defaultMessage: 'Buyer'
  },
  seller: {
    id: 'listPriceConfirmStep.seller',
    description: 'Seller text.',
    defaultMessage: 'Seller'
  },
  name: {
    id: 'listPriceConfirmStep.name',
    description: 'Name text.',
    defaultMessage: 'Name'
  },
  startDate: {
    id: 'listPriceConfirmStep.startDate',
    description: 'Start date text.',
    defaultMessage: 'Start Date'
  },
  endDate: {
    id: 'listPriceConfirmStep.endDate',
    description: 'End date text.',
    defaultMessage: 'End Date'
  },
  noEndDate: {
    id: 'listPriceConfirmStep.noEndDate',
    description: 'No end date text.',
    defaultMessage: 'No end date'
  },
  confirmContractDetails: {
    id: 'listPriceConfirmStep.confirmContractDetails',
    description: 'Confirm contract details text.',
    defaultMessage: 'Confirm Contract Details'
  },
  excludedSkus: {
    id: 'listPriceConfirmStep.excludedSkus',
    description: 'Excluded skus text.',
    defaultMessage: 'Excluded ({count})'
  },
  includedSkus: {
    id: 'listPriceConfirmStep.includedSkus',
    description: 'Included skus text.',
    defaultMessage: 'Skus ({count})'
  }
});
exports.listPriceConfirmStep = listPriceConfirmStep;